<script lang="ts">
  import flatpickr from 'flatpickr'
  import 'flatpickr/dist/flatpickr.css'
  import { onMount } from 'svelte'

  let {
    id = '',
    value = $bindable(''),
    format = 'h:i K',
    editable = false,
    required = false,
    placeholder = 'Select time',
  } = $props()

  let el
  let fp;

  onMount(() => {
    fp = flatpickr(el, {
      dateFormat: format,
      enableTime: true,
      noCalendar: true,
      // defaultDate: value,
      onChange(selectedDates, dateStr) {
        value = dateStr
      },
    })
  })

  function open(evt) {
    evt.preventDefault();
    console.log('setting value: ', value)
    fp?.setDate(value, false); // `false` prevents triggering the event again
    fp?.open()
  }

  function syncTime(evt) {
    // evt.preventDefault();
    console.log('syncing time: ', value)
    fp?.setDate(value, false); // `false` prevents triggering the event again
  }
</script>

<div>
  <input
    {id}
    class="form-control"
    bind:value
    bind:this={el}
    data-lpignore
    {required}
    {placeholder}
    type="text"
    onfocus={syncTime}
  />

  {#if editable}
    <button
      type="button"
      class="timepicker-trigger"
      onclick={open}
      aria-label="Open time picker"
    >&nbsp;</button>
  {/if}
</div>
